<div class="breadcrumb-container">
  @for (breadcrumb of breadcrumbs; track breadcrumb.label) {
    @if ($index !== breadcrumbs.length - 1) {
      <p class="breadcrumb-link">{{ breadcrumb.label }}</p>
      <p class="divider"><strong> > </strong></p>
    }
    @if ($index === breadcrumbs.length - 1) {
      <p class="breadcrumb-link route-name">{{ breadcrumb.label }}</p>
    }
  }
</div>
